module.exports = __webpack_public_path__ + "static/media/Flame Premium.51373d61.png";